import { createApi } from '@reduxjs/toolkit/query/react'
import {baseQuery} from "../baseQuery";

const refetchSeconds = process.env.REACT_APP_REFETCH_SECONDS ? parseInt(process.env.REACT_APP_REFETCH_SECONDS) : 30;

export const animeApi = createApi({
    reducerPath: 'animeApi',
    baseQuery,
    tagTypes: ["anime", "animeCount"],
    keepUnusedDataFor: 300,
    refetchOnMountOrArgChange: refetchSeconds,
    endpoints: (builder) => ({
        searchAnime: builder.query({
            query: (body) => ({
                url: `search`,
                method: 'POST',
                body,
            }),
            providesTags: ['anime']
        }),
        updateAnime: builder.mutation({
            query: ({animeId, ...body}) => ({
                url: `anime-items/${animeId}`,
                method: 'PUT',
                body
            }),
            invalidatesTags: ["anime"]
        }),
        createAnime: builder.mutation({
            query: ({animeId, genres, ...body}) => ({
                url: `anime-items`,
                method: 'POST',
                body
            }),
            invalidatesTags: ["anime"]
        }),
        getAnimeCountByGenre: builder.query({
            query: () => `anime-items/count`,
            providesTags: ["animeCount"]
        }),
        getAnimeByGenre: builder.query({
            query: ({genre, page = 1}) => ({url: `genres/${genre}/anime-items/${page}`}),
            providesTags: ['anime']
        }),
        createAnimeFromApi: builder.mutation({
            query: ({...body}) => ({
                url: `anime-items/api/add`,
                method: 'POST',
                body
            }),
            invalidatesTags: ["anime"]
        })
    }),
});

export const {
    useLazySearchAnimeQuery,
    useUpdateAnimeMutation,
    useCreateAnimeMutation,
    useLazyGetAnimeCountByGenreQuery,
    useLazyGetAnimeByGenreQuery,
    useCreateAnimeFromApiMutation
} = animeApi;
